import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => {
  const handleWhatsApp = () => {
    const phoneNumber = "919986671810";
    const message = "Hello! I would like to book an appointment at AyurvedMed Healthcare.";

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={handleWhatsApp}
      className="whatsapp-float"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      type="button"
    >
      <MessageCircle className="w-7 h-7 text-white" />
    </button>
  );
};

export default WhatsAppFloat;
